import React, { FC } from 'react'
import { Typography, Box, makeStyles, Grid } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { DedicatedLanesBid } from 'apps/fleet-planner/types/apiTypes'
import { formatBidText } from 'apps/fleet-planner/utils/dedicatedLanesHelpers'
import { Card } from 'transfix-ui'

interface IDedicatedLanesBidCardProps {
  bid: DedicatedLanesBid
}

const useDedicatedLanesBidCardStyles = makeStyles(() => ({
  bid: {
    color: brandColors.info,
  },
}))

export const DedicatedLanesBidCard: FC<IDedicatedLanesBidCardProps> = ({ bid }) => {
  const { carrierApplicationLegalName = 'your carrier', weeklyLoadVolume } = bid || {}
  const classes = useDedicatedLanesBidCardStyles()

  return (
    <Card className='pa4'>
      <Grid container spacing={1}>
        <Grid item xs={10}>
          <Box>
            {' '}
            <Typography
              variant='subtitle2'
              className={classes.bid}
              component='span'
              data-test='dedicated-lanes-bid-card-volume'>
              {formatBidText(bid)} · {weeklyLoadVolume} loads per week
            </Typography>
          </Box>
          <Box>
            <Typography variant='subtitle2' noWrap data-test='dedicated-lanes-carrier-name'>
              Your bid for {carrierApplicationLegalName}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Card>
  )
}
